import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  layout: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
    width: "100wh",
  }
}));

export default useStyles;